import * as IF from "infrontjs";
import template from './template.html';

class TemplateCard extends HTMLElement
{
    constructor()
    {
        super();
        this._isConnected = false;
        this._template = null;
    }

    connectedCallback()
    {
        if ( false === this._isConnected )
        {
            this.app = IF.App.get();
            this.render();

            this._isConnected = true;
        }
    }

    get template()
    {
        return this._template;
    }

    set template( val )
    {
        this._template = val;
        if ( this._isConnected )
        {
            this.render();
        }
    }

    _getDescription()
    {
        if ( !this._template?.description )
        {
            return 'No description';
        }
        const desc = this._template.description;
        return desc.length > 100 ? desc.substring( 0, 100 ) + '...' : desc;
    }

    _formatDate( dateStr )
    {
        if ( !dateStr )
        {
            return '---';
        }
        return new Date( dateStr ).toLocaleDateString();
    }

    render()
    {
        if ( !this.app?.view || !this._template )
        {
            return;
        }

        this.app.view.render(
            this,
            template,
            {
                template: this._template,
                description: this._getDescription(),
                createdAt: this._formatDate( this._template.createdAt ),
                updatedAt: this._formatDate( this._template.updatedAt )
            }
        );

        const deleteButton = this.querySelector( '[data-type="template-card-delete"]' );
        if ( deleteButton )
        {
            deleteButton.addEventListener( 'click', () => {
                this.dispatchEvent( new CustomEvent( 'delete', {
                    detail: { templateId: this._template.id },
                    bubbles: true
                }));
            });
        }

        const toggleStatusButton = this.querySelector( '[data-type="template-card-toggle-status"]' );
        if ( toggleStatusButton )
        {
            toggleStatusButton.addEventListener( 'click', () => {
                this._onToggleStatus();
            });
        }
    }

    async _onToggleStatus()
    {
        const isActive = this._template.status === 'ACTIVE';
        const action = isActive ? 'deactivate' : 'activate';
        const actionLabel = isActive ? 'Deactivate' : 'Activate';

        const confirmed = await this.app.view.confirm(
            `${actionLabel} Template`,
            `Do you want to ${action} this template?`
        );

        if ( confirmed )
        {
            const pageContent = this.app.view.pageContent;
            const message = isActive ? 'Deactivating template...' : 'Activating template...';
            this.app.view.blockUI( pageContent, message );

            const newStatus = isActive ? 'INACTIVE' : 'ACTIVE';
            const { result } = await this.app.api.put(
                `/template/${this._template.id}/status`,
                { status: newStatus }
            );

            this.app.view.unblockUI( pageContent );

            if ( result.status === 200 )
            {
                this._template.status = newStatus;
                this.render();
                this.app.view.toast( `Template ${action}d successfully`, 'success' );
            }
            else
            {
                this.app.view.toast( `Failed to ${action} template`, 'error' );
            }
        }
    }
}

customElements.define( 'template-card', TemplateCard );
